var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.116 12.833a1.333 1.333 0 10-1.885 1.886L22.56 20l-5.28 5.28a1.333 1.333 0 101.886 1.885l6.222-6.222c.26-.26.388-.599.388-.943s-.13-.682-.39-.943l-6.27-6.224zM20 5.778C12.144 5.778 5.777 12.145 5.777 20c0 7.856 6.367 14.222 14.223 14.222 7.855 0 14.222-6.366 14.222-14.222 0-7.855-6.367-14.222-14.222-14.222zm0 25.778c-6.373 0-11.556-5.184-11.556-11.556 0-6.372 5.183-11.556 11.556-11.556 6.372 0 11.555 5.184 11.555 11.556 0 6.372-5.183 11.556-11.555 11.556z",
    fill: "#FFBA33"
  })));
}
export default SvgArrowCircle;